(() => {
  function formatMoney(cents, currencyCode) {
    const amount = Number(cents || 0) / 100;
    return `${amount.toLocaleString(undefined, {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    })} ${currencyCode || ''}`.trim();
  }

  function updateDetails(panel, variant, sectionId) {
    if (!panel || !variant) return;

    const price = panel.querySelector('[data-wearse-detail-price]');
    if (price) {
      const currencyCode = document.querySelector(`#variant-selects-${sectionId}`)?.dataset.currencyCode;
      price.textContent = formatMoney(variant.price, currencyCode);
    }

    panel.querySelectorAll('[data-wearse-detail-option-row]').forEach((row) => {
      const index = Number(row.dataset.optionIndex || 0);
      const value = variant.options?.[index];
      row.hidden = !value;
      const cell = row.querySelector('[data-wearse-detail-option]');
      if (cell && value) cell.textContent = value;
    });

    const skuRow = panel.querySelector('[data-wearse-detail-sku-row]');
    const sku = panel.querySelector('[data-wearse-detail-sku]');
    if (skuRow && sku) {
      skuRow.hidden = !variant.sku;
      sku.textContent = variant.sku || '';
    }

    const availability = panel.querySelector('[data-wearse-detail-availability]');
    if (availability) availability.textContent = variant.available ? 'Disponible' : 'Indisponible';
  }

  function getDirectOrderVariant(form, variantId) {
    try {
      const variants = JSON.parse(form.querySelector('[data-wearse-direct-order-variants]')?.textContent || '[]');
      return variants.find((variant) => String(variant.id) === String(variantId)) || null;
    } catch {
      return null;
    }
  }

  function getDirectOrderVariants(form) {
    try {
      return JSON.parse(form.querySelector('[data-wearse-direct-order-variants]')?.textContent || '[]');
    } catch {
      return [];
    }
  }

  function getVariantSelections(row) {
    return [...row.querySelectorAll('[data-option-index]')].reduce((values, input) => {
      if (input.tagName === 'SELECT' || input.checked) values[Number(input.dataset.optionIndex)] = input.value;
      return values;
    }, []);
  }

  function findSelectedVariant(variants, selections) {
    return variants.find((variant) =>
      variant.available && variant.options?.every((value, index) => value === selections[index])
    );
  }

  function updateVariantRows(form) {
    const variants = getDirectOrderVariants(form);
    const rows = [...form.querySelectorAll('[data-wearse-direct-order-variant-row]')];
    let valid = true;

    rows.forEach((row) => {
      const selections = getVariantSelections(row);
      const selectedVariant = findSelectedVariant(variants, selections);
      row.dataset.variantId = selectedVariant?.id || '';
      valid = valid && Boolean(selectedVariant);

      row.querySelectorAll('select[data-option-index]').forEach((select) => {
        const optionIndex = Number(select.dataset.optionIndex);
        [...select.options].forEach((option) => {
          const candidate = [...selections];
          candidate[optionIndex] = option.value;
          option.disabled = !variants.some((variant) =>
            variant.available && variant.options?.every((value, index) => value === candidate[index])
          );
        });
      });
    });

    const firstVariantId = rows[0]?.dataset.variantId || '';
    const hiddenVariant = form.querySelector('input.product-variant-id');
    if (hiddenVariant) hiddenVariant.value = firstVariantId;
    const submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = !valid;
    return valid;
  }

  function renderVariantRows(form) {
    const variants = getDirectOrderVariants(form);
    const container = form.querySelector('[data-wearse-direct-order-variant-groups]');
    const optionNames = String(form.dataset.optionNames || '').split('||');
    const quantity = Math.max(1, Number(form.elements.offer_quantity?.value || 1));
    if (!container || !variants.length) return;

    const previous = [...container.querySelectorAll('[data-wearse-direct-order-variant-row]')].map(getVariantSelections);
    const fallback = variants.find((variant) => variant.available) || variants[0];
    const optionValues = optionNames.map((_, optionIndex) => [
      ...new Set(variants.map((variant) => variant.options?.[optionIndex]).filter(Boolean)),
    ]);
    container.replaceChildren();

    for (let itemIndex = 0; itemIndex < quantity; itemIndex += 1) {
      const selections = previous[itemIndex]?.length ? previous[itemIndex] : [...(fallback.options || [])];
      const row = document.createElement('fieldset');
      row.className = 'wearse-direct-order__variant-row';
      row.dataset.wearseDirectOrderVariantRow = '';
      const legend = document.createElement('legend');
      legend.textContent = `${form.dataset.productTitle} ${itemIndex + 1}`;
      row.append(legend);

      const optionGrid = document.createElement('div');
      optionGrid.className = 'wearse-direct-order__variant-options-grid';

      optionNames.forEach((optionName, optionIndex) => {
        const group = document.createElement('label');
        group.className = 'wearse-direct-order__option';
        const title = document.createElement('span');
        title.className = 'wearse-direct-order__option-title';
        title.textContent = /colou?r/i.test(optionName) ? 'Couleur' : optionName;
        const select = document.createElement('select');
        select.name = `item_${itemIndex + 1}_option_${optionIndex + 1}`;
        select.dataset.optionIndex = String(optionIndex);
        select.setAttribute('aria-label', `${title.textContent} - ${form.dataset.productTitle} ${itemIndex + 1}`);

        optionValues[optionIndex].forEach((value, valueIndex) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.selected = selections[optionIndex] === value;
          select.append(option);
        });

        group.append(title, select);
        optionGrid.append(group);
      });
      row.append(optionGrid);
      container.append(row);
    }

    updateVariantRows(form);
  }

  function updateDirectOrder(form, variant) {
    if (!form || !variant) return;

    const submit = form.querySelector('button[type="submit"]');
    const submitText = form.querySelector('[data-wearse-direct-order-submit-text]');

    if (submit) {
      submit.disabled = !variant.available;
      submit.setAttribute('aria-disabled', String(!variant.available));
    }
    if (submitText) submitText.textContent = variant.available ? 'Commander maintenant' : 'Indisponible';
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`) || document.querySelector('product-info');
      updateDetails(productInfo?.querySelector('[data-wearse-product-details]'), data.variant, data.sectionId);
      updateDirectOrder(productInfo?.querySelector('[data-wearse-direct-order]'), data.variant);
    });
  }

  document.querySelectorAll('[data-wearse-direct-order]').forEach((form) => {
    renderVariantRows(form);
    form.addEventListener('change', (event) => {
      if (event.target.name === 'offer_quantity') renderVariantRows(form);
      else if (event.target.matches('[data-option-index]')) updateVariantRows(form);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const feedback = form.querySelector('[data-wearse-direct-order-feedback]');
      const submit = form.querySelector('button[type="submit"]');
      const submitText = form.querySelector('[data-wearse-direct-order-submit-text]');

      if (!form.reportValidity()) return;

      const quantity = Math.max(1, Number(form.elements.offer_quantity?.value || 1));
      const variants = getDirectOrderVariants(form);
      const selectedVariants = [...form.querySelectorAll('[data-wearse-direct-order-variant-row]')]
        .map((row) => findSelectedVariant(variants, getVariantSelections(row)));
      if (selectedVariants.length !== quantity || selectedVariants.some((variant) => !variant)) {
        if (feedback) {
          feedback.textContent = 'Une combinaison choisie est indisponible. Veuillez modifier votre choix.';
          feedback.classList.add('is-error');
          feedback.hidden = false;
        }
        return;
      }

      const fields = new FormData(form);
      const phoneValue = String(fields.get('phone') || '').replace(/^\s*\+?212/, '').replace(/^0/, '').trim();
      const optionNames = String(form.dataset.optionNames || '').split('||');
      const title = form.dataset.productTitle || document.title;
      const currency = window.Shopify?.currency?.active || 'MAD';
      const offerPrices = String(form.dataset.offerPrices || '').split(',').map(Number);
      const totalPrice = offerPrices[quantity - 1] || selectedVariants.reduce((total, variant) => total + variant.price, 0);
      const payload = {
        landing: 'store',
        form_type: 'product_detail',
        source: window.location.href,
        submitted_at: new Date().toISOString(),
        product_title: title,
        full_name: String(fields.get('full_name') || '').trim(),
        phone: `+212${phoneValue}`,
        city: String(fields.get('city') || '').trim(),
        offer_label: `${quantity} ${form.dataset.offerLabel}${quantity > 1 ? 's' : ''}`,
        message: `Offre: ${quantity} ${form.dataset.offerLabel}${quantity > 1 ? 's' : ''}`,
        currency,
        total_price: totalPrice,
        total_price_label: formatMoney(totalPrice, currency),
        item_count: quantity,
        payment_method: 'Paiement à la livraison',
        user_agent: navigator.userAgent,
        lines: selectedVariants.map((variant) => ({
          product_title: title,
          variant_title: variant.title || '',
          variant_id: variant.id,
          quantity: 1,
          currency,
          options: (variant.options || []).map((value, index) => ({
            name: optionNames[index] || `Option ${index + 1}`,
            value,
          })),
        })),
      };

      submit.disabled = true;
      submit.classList.add('loading');
      if (submitText) submitText.textContent = 'Envoi en cours...';
      if (feedback) feedback.hidden = true;

      try {
        await fetch(form.dataset.endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
        });
        form.reset();
        renderVariantRows(form);
        if (feedback) {
          feedback.textContent = 'Votre commande a bien été enregistrée. Nous vous contacterons pour la confirmer.';
          feedback.classList.remove('is-error');
          feedback.hidden = false;
        }
        window.location.assign('https://www.wearse.com/pages/merci-commande-pantalon-fr');

      } catch {
        if (feedback) {
          feedback.textContent = "Une erreur s'est produite. Veuillez réessayer.";
          feedback.classList.add('is-error');
          feedback.hidden = false;
        }
      } finally {
        submit.disabled = !updateVariantRows(form);
        submit.classList.remove('loading');
        if (submitText) submitText.textContent = submit.disabled ? 'Indisponible' : 'Commander maintenant';
      }
    });
  });

  const desktopHoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  document.querySelectorAll('.product__media').forEach((media) => {
    media.addEventListener('mousemove', (event) => {
      if (!desktopHoverQuery.matches || !media.closest('product-info[data-zoom-on-hover]')) return;
      const image = media.querySelector('img');
      if (!image) return;

      const rect = media.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      image.style.transformOrigin = `${x}% ${y}%`;
      image.classList.add('is-zoomed');
    });

    media.addEventListener('mouseleave', () => {
      const image = media.querySelector('img');
      if (!image) return;
      image.classList.remove('is-zoomed');
      image.style.transformOrigin = '';
    });
  });

  document.querySelectorAll('[data-wearse-product-tabs]').forEach((tabsRoot) => {
    const tabs = [...tabsRoot.querySelectorAll('[data-wearse-product-tab]')];
    const panels = [...tabsRoot.querySelectorAll('[data-wearse-product-tab-panel]')];

    const activateTab = (tab) => {
      const target = tab.dataset.wearseProductTab;
      tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.wearseProductTabPanel !== target;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(index + offset + tabs.length) % tabs.length];
        activateTab(nextTab);
        nextTab.focus();
      });
    });
  });

  document.querySelectorAll('[data-wearse-customer-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-wearse-gallery-viewport]');
    const firstSlide = gallery.querySelector('.wearse-customer-gallery__slide');
    if (!viewport || !firstSlide) return;

    const move = (direction) => {
      const track = gallery.querySelector('.wearse-customer-gallery__track');
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      viewport.scrollBy({ left: direction * (firstSlide.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    gallery.querySelector('[data-wearse-gallery-prev]')?.addEventListener('click', () => move(-1));
    gallery.querySelector('[data-wearse-gallery-next]')?.addEventListener('click', () => move(1));
  });
})();